export enum RightTypeEnum {
    Incident,
    Observation,
    Right,
    AccessPointEvent,
    Master,
    Mobile,
    GraveSites,
    Occurrence,
}
